import { $http, buildHeaders } from "./index";

//上传附件
export const attachment_upload = (data) => {
  let headers = buildHeaders(3, "正在提交数据，请稍后……");
  headers["Content-Type"] = "multipart/form-data";
  return $http.post("/admin/Attachment/upload", data, {
    headers,
  });
};

//删除附件
export const attachment_delete = (id) => {
  return $http.post(
    "/admin/Attachment/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};
